export default __webpack_public_path__ + "static/media/img20200226_100949.b237d801.jpg";